(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.osg-vat-price';
  const numberFormat = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const update = (price) => {
    if (window.Shopify?.currency?.active !== 'ZAR') return;
    const source = price.querySelector('.price__current .js-value');
    const inclusive = price.querySelector('.osg-vat-price__inclusive-value');
    if (!source || !inclusive) return;
    const match = source.textContent.match(/\d[\d\s,.]*\d|\d/);
    if (!match) return;
    const amount = Number(match[0].replace(/[,\s]/g, ''));
    if (!Number.isFinite(amount) || amount < 0) return;
    const cents = Math.round(amount * 100);
    const total = Math.round(cents * 115 / 100) / 100;
    const formatted = inclusive.textContent.replace(/\d[\d\s,.]*\d|\d/, numberFormat.format(total));
    if (inclusive.textContent !== formatted) inclusive.textContent = formatted;
  };
  const start = () => {
    const root = document.getElementById('main-content');
    if (!root) return;
    root.querySelectorAll(selector).forEach(update);
    new MutationObserver((records) => {
      const prices = new Set();
      records.forEach((record) => {
        const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!element || element.closest('.osg-vat-price__inclusive')) return;
        const price = element.closest(selector);
        if (price) prices.add(price);
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches(selector)) prices.add(node);
          node.querySelectorAll(selector).forEach((added) => prices.add(added));
        });
      });
      prices.forEach(update);
    }).observe(root, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
